import { FC, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';

type ICarousel = {
  images: Array<{ url: string }>;
  className?: string;
};
export const Carousel: FC<ICarousel> = ({ images, className }) => {
  const [active, setActive] = useState(0);
  return (
    <>
      <SlideshowContainer>
        {images.map((item, index) => (
          <Slides active={active === index} key={index.toString()}>
            <Img loading={'lazy'} className={className} src={item.url} />
          </Slides>
        ))}

        <Prev
          onClick={(e) => {
            setActive((prev) => (prev !== 0 ? prev - 1 : 0));
            e.stopPropagation();
          }}
        >
          &#10094;
        </Prev>
        <Next
          onClick={(e) => {
            setActive((prev) => (prev < images.length - 1 ? prev + 1 : prev));
            e.stopPropagation();
          }}
        >
          &#10095;
        </Next>
        <Container>
          {images.map((_, index) => (
            <Dot
              onClick={(e) => {
                setActive(index);
                e.stopPropagation();
              }}
              active={active === index}
              key={index.toString()}
            />
          ))}
        </Container>
      </SlideshowContainer>
    </>
  );
};

const Container = styled.div`
  text-align: center;
  position: absolute;
  bottom: 10%;
  display: flex;
  justify-content: center;
  right: 0;
  left: 0;
`;
const SlideshowContainer = styled.div`
  position: relative;
`;
const fade = keyframes`
    from {opacity: .4}
    to {opacity: 1}
`;
const Slides = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? 'block' : 'none')};
  -webkit-animation-name: ${fade};
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 4s;
`;
const Img = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 16px;
  object-fit: cover;
`;
const Prev = styled.a`
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: ${pxToRem(18)};
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
`;

const Next = styled(Prev)`
  right: 0;
  border-radius: 3px 0 0 3px;
`;

const Dot = styled.span<{ active: boolean }>`
  cursor: pointer;
  height: 6px;
  width: ${({ active }) => (active ? '24px' : '6px')};
  margin: 0 2px;
  background-color: ${({ active }) =>
    active ? colors.sojiOrange : colors.bgGrey};
  border-radius: ${({ active }) => (active ? '3.75px' : '50%')};
  display: inline-block;
  transition: background-color 0.6s ease;
`;
